import { useState, useEffect } from 'react';

import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import UserEditService from 'app/admin/user/service/UserEditService';
import EditFormRegistrationStatusField from 'modules/ui/editform/fields/EditFormRegistrationStatusField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormFileInputField from 'modules/ui/editform/fields/EditFormFileInputField';
import ProjectService from 'app/admin/project/service/ProjectService';

const config = data => {
	return {
		key: 'userEditForm',
		text: 'Access',
		textKey: 'user',
		service: UserEditService,
		icon: 'person',
		fields: [
			{
				key: 'name',
				text: 'Name',
				textKey: 'name',
				component: EditFormTextField,
				required: true
			},
			{
				key: 'email',
				text: 'E-mail',
				textKey: 'email',
				component: EditFormTextField,
				required: true
			},
			{
				key: 'profilePicture',
				text: 'Profile Picture',
				textKey: 'profilePicture',
				component: EditFormFileInputField,
				required: true
			},
			{
				key: 'roles',
				text: 'Roles',
				textKey: 'roleList',
				component: EditFormSelectField,
				multiple: true,
				type: 'enum',
				// items: data.formData.entityMap.roles
				items: () => UserEditService.getRoleListSelection()
			},
			{
				key: 'projects',
				text: 'Projects',
				textKey: 'projects',
				component: EditFormSelectField,
				multiple: true,
				items: () => ProjectService.getListSelection()
			},
			{
				key: 'registrationStatus',
				text: 'Active',
				textKey: 'registrationStatus',
				component: EditFormRegistrationStatusField
			},
			{
				key: 'password',
				text: 'Password',
				textKey: 'password',
				component: EditFormTextField,
				required: true,
				type: 'password',
				autoComplete: 'new-password'
			},
			{
				key: 'passwordAgain',
				text: 'Password again',
				textKey: 'passwordAgain',
				component: EditFormTextField,
				required: true,
				type: 'password',
				autoComplete: 'new-password'
			}
		]
	};
};

function toLabelValue(list) {
	if (!Array.isArray(list)) return [];
	return list.map(x => ({ label: x?.name ?? '', value: x?.name ?? '' }));
}

function normalizeFormData(result) {
	const roles = toLabelValue(result?.entityMap?.roles);
	// const roles = result?.entityMap?.roles;
	// const projects = toLabelValue(result?.entityMap?.projects);
	const projects = result?.entityMap?.projects;
	return {
		...result,
		entityMap: {
			...result.entityMap,
			roles,
			projects
		}
	};
}

function UserEditForm() {
	const [formData, setFormData] = useState(null);

	// useEffect(() => {
	// let alive = true;
	// UserEditService.getFormData()
	// 	.then(result => {
	// 		if (!alive) return;
	// 		console.log(normalizeFormData(result));
	// 		setFormData(normalizeFormData(result));
	// 	})
	// 	.catch(() => { /* swallow or log if needed */ });
	// return () => { alive = false; };
	// }, []);

	// if (formData == null) {
	// 	return <></>;
	// }

	const myConfig = config({ formData });

	return <EditFormPage config={myConfig} />;
}

export default UserEditForm;
